import type { KidAvatarColor } from '@brighterly/lib-lumee-ui'

const KID_AVATAR_POSITION_COLORS: readonly KidAvatarColor[] = ['pink', 'sky', 'sunshine', 'green', 'orange']
const KID_AVATAR_UNPOSITIONED_COLOR: KidAvatarColor = 'gray'
const KID_AVATAR_TEXT_LENGTH = 2

export const getKidAvatarColor = (position: number): KidAvatarColor => (
  KID_AVATAR_POSITION_COLORS[position % KID_AVATAR_POSITION_COLORS.length] ?? KID_AVATAR_UNPOSITIONED_COLOR
)

export const getKidAvatarText = (name: string): string => name.slice(0, KID_AVATAR_TEXT_LENGTH)
